import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import { useCreditCheck } from 'policy-lib';
import { ModalBulk } from '../ModalBulk/ModalBulk';
import { useBulkEnrichment } from './useBulkEnrichment';
import { Body } from 'breeze-intelligence-kit';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import { LiveEnrichmentDisclaimer } from '../LiveEnrichmentDisclaimer';
import { MODAL_MIN_BLOCK_SIZE } from '../../constants';
import { OverwriteSetting } from '../OverwriteSetting';
import { ObjectTypeLabel } from '../EnrichableObjectTypesProvider/EnrichmentLabels';
import { AssociatedRecords } from './useBulkEnrichment/AssociatedRecords';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const BulkEnrichmentModalContent = ({
  isOpen,
  onClose,
  onCloseComplete
}) => {
  const {
    count,
    isContactEnrichment,
    isLoading,
    onEnrich,
    setShouldOverwrite,
    shouldOverwrite
  } = useBulkEnrichment();
  const action = 'DATASET_ENRICHMENT';
  const {
    isAuthorized
  } = useCreditCheck({
    action,
    numberOfOperations: count
  });
  return /*#__PURE__*/_jsxs(ModalBulk, {
    isLoading: isLoading,
    isOpen: isOpen,
    onClose: onClose,
    onCloseComplete: onCloseComplete,
    children: [/*#__PURE__*/_jsx(ModalBulk.Header, {
      children: /*#__PURE__*/_jsx(ModalBulk.Heading, {
        children: /*#__PURE__*/_jsx(FormattedReactMessage, {
          message: "enrichmentProperties.modals.enrichRecords.title",
          options: {
            objectType: /*#__PURE__*/_jsx(ObjectTypeLabel, {
              isCapitalized: false,
              type: isContactEnrichment ? 'contact' : 'company'
            })
          }
        })
      })
    }), /*#__PURE__*/_jsxs(ModalBulk.Body, {
      minBlockSize: MODAL_MIN_BLOCK_SIZE,
      children: [/*#__PURE__*/_jsx(ModalBulk.UsageAlert, {
        action: action,
        numberOfOperations: count
      }), /*#__PURE__*/_jsxs(Body, {
        children: [/*#__PURE__*/_jsx(FormattedHTMLMessage, {
          message: "enrichmentProperties.modals.enrichRecords.body",
          options: {
            count
          }
        }), ' ', /*#__PURE__*/_jsx(FormattedMessage, {
          message: "enrichmentProperties.modals.enrichCycleMessage"
        })]
      }), /*#__PURE__*/_jsx(ModalBulk.UsageEstimate, {
        action: action,
        numberOfOperations: count
      }), /*#__PURE__*/_jsx(ModalBulk.Usage, {
        action: action
      }), /*#__PURE__*/_jsx(ModalBulk.UsageDisclaimer, {
        action: action,
        isVisible: isAuthorized
      }), /*#__PURE__*/_jsx(AssociatedRecords, {}), /*#__PURE__*/_jsx(OverwriteSetting, {
        checked: shouldOverwrite,
        id: "enrichBulk-overwrite",
        onChange: setShouldOverwrite
      }), /*#__PURE__*/_jsx(LiveEnrichmentDisclaimer, {
        isContactEnrichment: isContactEnrichment
      })]
    }), /*#__PURE__*/_jsx(ModalBulk.Footer, {
      children: /*#__PURE__*/_jsxs(ModalBulk.FooterActions, {
        children: [/*#__PURE__*/_jsx(ModalBulk.ButtonUsageCheck, {
          action: action,
          isLoading: isLoading,
          numberOfOperations: count,
          onClick: onEnrich,
          type: "submit",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "enrichmentProperties.modals.enrichRecords.enrich"
          })
        }), /*#__PURE__*/_jsx(ModalBulk.ButtonCancel, {
          onClick: onClose
        })]
      })
    })]
  });
};